import { render } from "./facilities-grid.vue?vue&type=template&id=14187ccf&scoped=true"
import script from "./facilities-grid.vue?vue&type=script&lang=js"
export * from "./facilities-grid.vue?vue&type=script&lang=js"

import "./facilities-grid.vue?vue&type=style&index=0&id=14187ccf&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14187ccf"]])

export default __exports__